import React,{useState,useEffect} from 'react'
import axios from 'axios'
import BestOffersHeader from './Components/BestOffers/BestOffersHeader'
import BestOffersTitle from './Components/BestOffers/BestOffersTitle'
import ImagesCoupons from './Components/Coupons/ImagesCoupons'
import styled from 'styled-components'
import SeasonalOffers from './Components/SeasonalOffers/SeasonalOffers'
import BestOffersCoupons from './Components/BestOffers/BestOffersCoupons'

const BestOffers = () => {
  const [images,setImages]= useState([]);

  useEffect(()=>{
    axios.get('https://api.bakpoket.com/api/Cat_TC_BO/get-Cat_TC_BO?position=BO')
    .then(res=>setImages(res.data))
    .catch(err=>console.log(err))
  })
  
  return (
    <Wrapper>
      <BestOffersHeader />
      <div className="container">
        <BestOffersTitle />
        {/* <ImagesCoupons /> */}
        <BestOffersCoupons/>
        {/* <BestOffersOffers /> */}
        <SeasonalOffers/>
        <div className="image-wrapper">
          {/* <img src="./images/bestoffers-ad.png" alt="Best Offers Ad" className="bestoffers-ad" /> */}

          {images && (
          <a
          href={`https://${images.merchantURL}`}
          target="_blank"
          rel="noopener noreferrer"
          >
          <img
          className="bestoffers-ad"
          src={`data:image/png;base64,${images.base64}`}
          alt="Best Offers Ad"
          />
          </a>
        )}     
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  .container {
    max-width: 1100px;
    width: 100%;
    margin: 0 auto;
    padding: 0 20px;
  }

  .image-wrapper {
    display: flex;
    justify-content: center;
    margin: 20px 0;
  }

  .bestoffers-ad {
    width: 100%;
    max-width: 100%;
    height: auto;
    border-radius: 6px;
  }

  @media (max-width: 480px) {
    .bestoffers-ad {
      width: 100%;
    }
  }
`

export default BestOffers
